import { Component, Input, ChangeDetectionStrategy } from '@angular/core';


/**
 * an ng-content focussed modal for wrapping Modals with
 */
@Component({
    selector: 'app-modal-wrapper',
    templateUrl: './modal-wrapper.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ModalWrapperComponent {

    /**
     * Key for top header title
     */
    @Input() TitleTranslationKey: string = "";
}

